import { KEY_REDUCER_PLAYER } from "./constants";

export const selectorPlayerWaveformsDictionary = (state) => {
  return state[KEY_REDUCER_PLAYER].waveformsDictionary;
};

export const selectorPlayerBrokenAudios = (state) => {
  return state[KEY_REDUCER_PLAYER].brokenAudios;
};

export const selectorIsSmallPlayerVisible = (state) => {
  return state[KEY_REDUCER_PLAYER].isSmallPlayerVisible;
};
